import React, { useState, useRef, useEffect } from 'react';

const Window = ({ 
  id, 
  title, 
  content, 
  position, 
  isOpen, 
  isFocused,
  onClose, 
  onMinimize, 
  onMaximize, 
  onFocus, 
  onStartDrag 
}) => {
  const [windowPosition, setWindowPosition] = useState(position);
  const [isMaximized, setIsMaximized] = useState(false);
  const windowRef = useRef(null);

  useEffect(() => {
    if (isOpen && windowRef.current) {
      windowRef.current.style.zIndex = Math.max(
        ...Array.from(document.querySelectorAll('.window')).map(w => 
          parseInt(w.style.zIndex) || 100
        )
      ) + 1;
    }
  }, [isOpen]);

  const handleMaximize = () => {
    if (isMaximized) {
      setWindowPosition(position);
      setIsMaximized(false);
    } else {
      setWindowPosition({
        top: 10,
        left: 10,
        width: window.innerWidth <= 768 ? 'calc(100vw - 20px)' : 'calc(100vw - 20px)',
        height: window.innerWidth <= 768 ? 'calc(100vh - 100px)' : 'calc(100vh - 100px)'
      });
      setIsMaximized(true);
    }
    onMaximize();
  };

  const handleHeaderClick = (e) => {
    if (e.target.closest('.window-control')) return;
    onFocus();
  };

  const handleMouseDown = (e) => {
    if (window.innerWidth <= 768) return;
    onStartDrag(e, windowRef.current);
  };

  const handleTouchStart = (e) => {
    if (window.innerWidth <= 768) return;
    onStartDrag(e, windowRef.current);
  };

  if (!isOpen) return null;

  return (
    <div
      ref={windowRef}
      className={`window active ${isFocused ? 'focused' : ''}`}
      style={{
        top: windowPosition.top,
        left: windowPosition.left,
        width: windowPosition.width,
        height: windowPosition.height,
        ...(window.innerWidth <= 768 && {
          width: 'calc(100vw - 20px)',
          height: 'calc(100vh - 100px)',
          top: '10px',
          left: '10px'
        })
      }}
      role="dialog"
      aria-labelledby={`${id}-title`}
    >
      <div 
        className="window-header"
        onClick={handleHeaderClick}
        onMouseDown={handleMouseDown}
        onTouchStart={handleTouchStart}
      >
        <span className="window-title" id={`${id}-title`}>
          {title}
        </span>
        <div className="window-controls">
          <div 
            className="window-control minimize" 
            onClick={onMinimize}
            onKeyDown={(e) => {
              if (e.key === 'Enter' || e.key === ' ') {
                e.preventDefault();
                onMinimize();
              }
            }}
            tabIndex="0" 
            role="button" 
            aria-label="Minimize"
          >
            −
          </div>
          <div 
            className="window-control maximize" 
            onClick={handleMaximize}
            onKeyDown={(e) => {
              if (e.key === 'Enter' || e.key === ' ') {
                e.preventDefault();
                handleMaximize();
              }
            }}
            tabIndex="0" 
            role="button" 
            aria-label="Maximize"
          >
            □
          </div>
          <div 
            className="window-control close" 
            onClick={onClose}
            onKeyDown={(e) => {
              if (e.key === 'Enter' || e.key === ' ') {
                e.preventDefault();
                onClose();
              }
            }}
            tabIndex="0" 
            role="button" 
            aria-label="Close"
          >
            ×
          </div>
        </div>
      </div>
      <div className="window-content">
        {content}
      </div>
    </div>
  );
};

export default Window;
